import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_whatsapp.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_cod_amount.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_o_dex_package.svg'
import _imports_3 from '@/app/ui/assets/svg/ics_o_cod_rej.svg'
import _imports_4 from '@/app/ui/assets/svg/ics_o_on_delivery.svg'


const _hoisted_1 = { class: "h-full overflow-y-auto" }
const _hoisted_2 = { class: "flex flex-row justify-between items-center" }
const _hoisted_3 = { class: "flex flex-row items-center justify-between" }
const _hoisted_4 = {
  class: "flex flex-row",
  style: {"margin-right":"40px"}
}
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "ml-2",
  src: _imports_0,
  alt: "wa-icon"
}, null, -1)
const _hoisted_6 = { class: "flex flex-row" }
const _hoisted_7 = { class: "my-4 flex flex-row px-6 py-4 total-stt-collect text-red-lp-100 font-semibold text-xl rounded-md" }
const _hoisted_8 = {
  class: "flex flex-row items-center w-1/2 justify-between border-r border-pink-lp-300",
  style: {"padding-right":"30px"}
}
const _hoisted_9 = {
  "data-testid": "cod-reconcile-detail-amount-pending",
  class: "text-2xl font-bold"
}
const _hoisted_10 = {
  class: "flex flex-row items-center w-1/2 justify-between",
  style: {"padding-left":"30px"}
}
const _hoisted_11 = { class: "font-semibold" }
const _hoisted_12 = { class: "font-bold text-2xl" }
const _hoisted_13 = { class: "flex flex-row items-center text-base text-gray-lp-800" }
const _hoisted_14 = { class: "w-1/4" }
const _hoisted_15 = { class: "flex flex-row items-center" }
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  class: "mr-1",
  src: _imports_1,
  alt: "cod-amount-icon"
}, null, -1)
const _hoisted_17 = { class: "text-gray-lp-300 font-bold text-xl mt-1" }
const _hoisted_18 = { class: "flex flex-row items-center justify-between text-sm mt-2" }
const _hoisted_19 = { class: "flex flex-col" }
const _hoisted_20 = {
  "data-testid": "cod-reconcile-detail-amount-pending",
  class: "font-bold text-red-lp-100"
}
const _hoisted_21 = { class: "flex flex-col" }
const _hoisted_22 = {
  "data-testid": "cod-reconcile-detail-amount-collected",
  class: "font-bold text-gray-lp-300"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("div", {
  class: "mx-4 border-r border-gray-lp-1400",
  style: {"height":"100px"}
}, null, -1)
const _hoisted_24 = { class: "w-1/4" }
const _hoisted_25 = { class: "flex flex-row items-center" }
const _hoisted_26 = /*#__PURE__*/_createVNode("img", {
  class: "mr-1",
  src: _imports_2,
  alt: "cod-amount-icon"
}, null, -1)
const _hoisted_27 = { class: "text-gray-lp-300 mt-1" }
const _hoisted_28 = { class: "text-xl font-bold inline" }
const _hoisted_29 = { class: "flex flex-row items-center justify-between text-sm mt-2" }
const _hoisted_30 = { class: "flex flex-col" }
const _hoisted_31 = { class: "text-red-lp-100 text-xs inline" }
const _hoisted_32 = { class: "text-sm font-bold inline" }
const _hoisted_33 = { class: "flex flex-col" }
const _hoisted_34 = { class: "text-gray-lp-300 text-xs inline" }
const _hoisted_35 = { class: "text-sm font-bold inline" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", {
  class: "mx-4 border-r border-gray-lp-1400",
  style: {"height":"100px"}
}, null, -1)
const _hoisted_37 = { class: "w-1/4" }
const _hoisted_38 = { class: "flex flex-row items-center" }
const _hoisted_39 = /*#__PURE__*/_createVNode("img", {
  class: "mr-1",
  src: _imports_3,
  alt: "cod-amount-icon"
}, null, -1)
const _hoisted_40 = { class: "text-gray-lp-300 mt-1" }
const _hoisted_41 = { class: "text-xl font-bold inline" }
const _hoisted_42 = { class: "flex flex-row items-center justify-between text-sm mt-2" }
const _hoisted_43 = { class: "flex flex-col" }
const _hoisted_44 = { class: "text-red-lp-100 text-xs inline" }
const _hoisted_45 = { class: "text-sm font-bold inline" }
const _hoisted_46 = { class: "flex flex-col" }
const _hoisted_47 = { class: "text-gray-lp-300 text-xs inline" }
const _hoisted_48 = { class: "text-sm font-bold inline" }
const _hoisted_49 = /*#__PURE__*/_createVNode("div", {
  class: "mx-4 border-r border-gray-lp-1400",
  style: {"height":"100px"}
}, null, -1)
const _hoisted_50 = { class: "w-1/4 pr-4" }
const _hoisted_51 = { class: "flex flex-row items-center" }
const _hoisted_52 = /*#__PURE__*/_createVNode("img", {
  class: "mr-1",
  src: _imports_4,
  alt: "cod-amount-icon"
}, null, -1)
const _hoisted_53 = { class: "text-gray-lp-300 mt-1" }
const _hoisted_54 = { class: "text-xl font-bold inline" }
const _hoisted_55 = { class: "flex flex-row items-center justify-between text-sm mt-2" }
const _hoisted_56 = { class: "flex flex-col" }
const _hoisted_57 = { class: "text-red-lp-100 text-xs inline" }
const _hoisted_58 = { class: "text-sm font-bold inline" }
const _hoisted_59 = { class: "flex flex-col" }
const _hoisted_60 = { class: "text-gray-lp-300 text-xs inline" }
const _hoisted_61 = { class: "text-sm font-bold inline" }
const _hoisted_62 = { class: "text-green-lp-400 font-semibold text-base" }
const _hoisted_63 = { class: "font-bold" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString(" ") + " ")
const _hoisted_65 = { class: "font-normal" }
const _hoisted_66 = { class: "overflow-auto relative cod-reconcile-detail-courier-table" }
const _hoisted_67 = { class: "text-red-lp-100 font-semibold text-base" }
const _hoisted_68 = { class: "font-bold" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString(" ") + " ")
const _hoisted_70 = { class: "font-normal" }
const _hoisted_71 = { class: "overflow-auto relative cod-reconcile-detail-courier-table" }
const _hoisted_72 = { class: "h-full overflow-y-auto" }
const _hoisted_73 = { class: "flex flex-row justify-between items-center" }
const _hoisted_74 = { class: "text-gray-lp-300 font-semibold text-base" }
const _hoisted_75 = { class: "font-bold" }
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString(" ") + " ")
const _hoisted_77 = { class: "font-normal" }
const _hoisted_78 = { class: "overflow-auto relative cod-reconcile-detail-courier-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_PopupSetorHarian = _resolveComponent("PopupSetorHarian")!
  const _component_PopupHarusDisetor = _resolveComponent("PopupHarusDisetor")!
  const _component_WidgetDownload = _resolveComponent("WidgetDownload")!
  const _component_PopupBerhasilSetorPaket = _resolveComponent("PopupBerhasilSetorPaket")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    onBack: _ctx.goBack,
    error: _ctx.errorCause.length,
    errorType: _ctx.errorCause,
    onTryAgain: _ctx.fetchDetailCourier,
    loading: _ctx.detailCourierLoading,
    fullPage: ""
  }, {
    title: _withCtx(() => [
      _createVNode("span", null, _toDisplayString(_ctx.detail.title), 1)
    ]),
    data: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_DatePicker, {
            modelValue: _ctx.filterDate,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterDate = $event)),
            onSelected: _ctx.onFilterDate,
            maxDate: _ctx.maxDate
          }, null, 8, ["modelValue", "onSelected", "maxDate"]),
          (_ctx.pendingReconcileData.length)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: "collect-remaining-button py-2 px-4 rounded-md text-red-lp-100 font-bold flex flex-row items-center",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickOpenPopupAmountDue && _ctx.onClickOpenPopupAmountDue(...args)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t("codReconcile.detail.checkRemainingDeposit")) + " ", 1),
                _createVNode(_component_Icons, {
                  name: "chevron-right",
                  class: "text-red-lp-100 ml-3"
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Card, {
          class: "p-4 mb-4 mt-3",
          rounded: "2xl"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('codReconcile.detail.courierName'),
                  value: 
                  !_ctx.detailCourierLoading &&
                    _ctx.dashboardDeliveryCourierDetail.fullname
                
                }, {
                  default: _withCtx(() => [
                    (_ctx.detailCourierLoading)
                      ? (_openBlock(), _createBlock(_component_Skeleton, {
                          key: 0,
                          class: "mt-2",
                          width: "10rem"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label", "value"]),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('codReconcile.detail.phoneNumber'),
                  style: {"margin-left":"40px"}
                }, {
                  default: _withCtx(() => [
                    (!_ctx.detailCourierLoading)
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          class: "flex flex-row items-center text-xs xxl:text-sm",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickWhatsapp && _ctx.onClickWhatsapp(...args)))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.dashboardDeliveryCourierDetail.phoneNumber) + " ", 1),
                          _hoisted_5
                        ]))
                      : (_openBlock(), _createBlock(_component_Skeleton, {
                          key: 1,
                          class: "mt-2",
                          width: "10rem"
                        }))
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('codReconcile.detail.courierId'),
                  value: 
                  !_ctx.detailCourierLoading &&
                    _ctx.dashboardDeliveryCourierDetail.courierId
                ,
                  style: {"margin-left":"40px"}
                }, {
                  default: _withCtx(() => [
                    (_ctx.detailCourierLoading)
                      ? (_openBlock(), _createBlock(_component_Skeleton, {
                          key: 0,
                          class: "mt-2",
                          width: "5rem"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label", "value"]),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('codReconcile.detail.partner'),
                  value: !_ctx.detailCourierLoading && _ctx.partnerName,
                  style: {"margin-left":"40px"}
                }, {
                  default: _withCtx(() => [
                    (_ctx.detailCourierLoading)
                      ? (_openBlock(), _createBlock(_component_Skeleton, {
                          key: 0,
                          class: "mt-2",
                          width: "15rem"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label", "value"]),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('codReconcile.detail.threeLc'),
                  value: !_ctx.detailCourierLoading && _ctx.courier3lc,
                  style: {"margin-left":"40px"}
                }, {
                  default: _withCtx(() => [
                    (_ctx.detailCourierLoading)
                      ? (_openBlock(), _createBlock(_component_Skeleton, {
                          key: 0,
                          class: "mt-2",
                          width: "10rem"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label", "value"])
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_lp_button, {
                  outline: "",
                  title: _ctx.$t('codReconcile.detail.downloadDetailCourier'),
                  "text-color": "red-lp-100",
                  iconLeft: "ics_o_download",
                  onClick: _ctx.downloadDetail
                }, null, 8, ["title", "onClick"]),
                (_ctx.showButtonDeposit)
                  ? (_openBlock(), _createBlock(_component_lp_button, {
                      key: 0,
                      class: "pl-3",
                      title: _ctx.detail.setor,
                      "text-color": "white",
                      iconV2: true,
                      iconColor: "white",
                      iconLeft: "icon-withdraw",
                      iconGroupHoverColor: "",
                      onClick: _ctx.downloadDeposit
                    }, null, 8, ["title", "onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", null, _toDisplayString(_ctx.$t("codReconcile.detail.totalMoneyToDeposit")), 1),
                _createVNode("div", _hoisted_9, _toDisplayString(_ctx.codAmountDepositPending), 1)
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode("div", null, _toDisplayString(_ctx.$t("codReconcile.detail.totalSttToDeposit")), 1),
                _createVNode("div", _hoisted_11, [
                  _createVNode("span", _hoisted_12, _toDisplayString(_ctx.sttDepositTotal) + " STT", 1),
                  _createTextVNode(_toDisplayString(" ") + "(" + _toDisplayString(_ctx.sttDepositTotalPieces) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ") ", 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("codReconcile.detail.totalCodMoney")), 1)
                ]),
                _createVNode("div", _hoisted_17, _toDisplayString(_ctx.totalCodAmount), 1),
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, [
                    _createTextVNode(_toDisplayString(_ctx.$t("codReconcile.list.mustDeposit")) + " ", 1),
                    _createVNode("div", _hoisted_20, _toDisplayString(_ctx.pendingCodAmount), 1)
                  ]),
                  _createVNode("div", _hoisted_21, [
                    _createTextVNode(_toDisplayString(_ctx.$t("codReconcile.list.alreadyDeposit")) + " ", 1),
                    _createVNode("div", _hoisted_22, _toDisplayString(_ctx.collectedCodAmount), 1)
                  ])
                ])
              ]),
              _hoisted_23,
              _createVNode("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("codReconcile.summary.dex")), 1)
                ]),
                _createVNode("div", _hoisted_27, [
                  _createVNode("div", _hoisted_28, _toDisplayString(_ctx.totalDex) + " STT", 1),
                  _createTextVNode(" " + _toDisplayString(" ") + " (" + _toDisplayString(_ctx.totalPiecexDex) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ") ", 1)
                ]),
                _createVNode("div", _hoisted_29, [
                  _createVNode("div", _hoisted_30, [
                    _createTextVNode(_toDisplayString(_ctx.$t("codReconcile.list.mustDeposit")) + " ", 1),
                    _createVNode("div", _hoisted_31, [
                      _createVNode("div", _hoisted_32, _toDisplayString(_ctx.pendingDex) + " STT ", 1),
                      _createTextVNode(" " + _toDisplayString(" ") + " (" + _toDisplayString(_ctx.pendingPiecexDex) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ") ", 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_33, [
                    _createTextVNode(_toDisplayString(_ctx.$t("codReconcile.list.alreadyDeposit")) + " ", 1),
                    _createVNode("div", _hoisted_34, [
                      _createVNode("div", _hoisted_35, _toDisplayString(_ctx.collectedDex) + " STT ", 1),
                      _createTextVNode(" " + _toDisplayString(" ") + " (" + _toDisplayString(_ctx.collectedPiecexDex) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ") ", 1)
                    ])
                  ])
                ])
              ]),
              _hoisted_36,
              _createVNode("div", _hoisted_37, [
                _createVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("codReconcile.summary.codrej")), 1)
                ]),
                _createVNode("div", _hoisted_40, [
                  _createVNode("div", _hoisted_41, _toDisplayString(_ctx.totalCodrej) + " STT ", 1),
                  _createTextVNode(" " + _toDisplayString(" ") + " (" + _toDisplayString(_ctx.totalPiecesCodrej) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ") ", 1)
                ]),
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, [
                    _createTextVNode(_toDisplayString(_ctx.$t("codReconcile.list.mustDeposit")) + " ", 1),
                    _createVNode("div", _hoisted_44, [
                      _createVNode("div", _hoisted_45, _toDisplayString(_ctx.pendingCodRej) + " STT ", 1),
                      _createTextVNode(" " + _toDisplayString(" ") + " (" + _toDisplayString(_ctx.pendingPiecesCodrej) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ") ", 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_46, [
                    _createTextVNode(_toDisplayString(_ctx.$t("codReconcile.list.alreadyDeposit")) + " ", 1),
                    _createVNode("div", _hoisted_47, [
                      _createVNode("div", _hoisted_48, _toDisplayString(_ctx.collectedCodrej) + " STT ", 1),
                      _createTextVNode(" " + _toDisplayString(" ") + " (" + _toDisplayString(_ctx.collectedPieceCodrej) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ") ", 1)
                    ])
                  ])
                ])
              ]),
              _hoisted_49,
              _createVNode("div", _hoisted_50, [
                _createVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("codReconcile.list.progressDelivery")), 1)
                ]),
                _createVNode("div", _hoisted_53, [
                  _createVNode("div", _hoisted_54, _toDisplayString(_ctx.totalInDelivery) + " STT ", 1),
                  _createTextVNode(" " + _toDisplayString(" ") + " (" + _toDisplayString(_ctx.totalPiecesInDelivery) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ") ", 1)
                ]),
                _createVNode("div", _hoisted_55, [
                  _createVNode("div", _hoisted_56, [
                    _createTextVNode(_toDisplayString(_ctx.$t("codReconcile.summary.del")) + " ", 1),
                    _createVNode("div", _hoisted_57, [
                      _createVNode("div", _hoisted_58, _toDisplayString(_ctx.totalDelInDelivery) + " STT ", 1),
                      _createTextVNode(" " + _toDisplayString(" ") + " (" + _toDisplayString(_ctx.totalPiecesDelInDelivery) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ") ", 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_59, [
                    _createTextVNode(_toDisplayString(_ctx.$t("codReconcile.summary.podCodrejDex")) + " ", 1),
                    _createVNode("div", _hoisted_60, [
                      _createVNode("div", _hoisted_61, _toDisplayString(_ctx.totalPodCodrejDex) + " STT ", 1),
                      _createTextVNode(" " + _toDisplayString(" ") + " (" + _toDisplayString(_ctx.totalPiecesPodCodrejDex) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ") ", 1)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Tabs, {
          modelValue: _ctx.activeMenu,
          onChange: _ctx.onChangeTabs,
          data: _ctx.tabs,
          rounded: false,
          titleSize: 16,
          gap: 10
        }, {
          default: _withCtx(() => [
            (_ctx.activeMenu === 'detail-stt')
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_Accordion, {
                    modelValue: _ctx.successDeliveryExpand,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.successDeliveryExpand = $event)),
                    label: _ctx.$t('codReconcile.detail.pengirimanBerhasil'),
                    class: "font-montserrat font-semibold text-20px text-black-lp-200 mb-3",
                    "border-header": 
                `border border-green-lp-400 ${
                  _ctx.successDeliveryExpand ? 'accordion-radius' : ''
                }`
              ,
                    mainBorderEdge: "",
                    "border-body": "accordion-body-radius ",
                    "custom-class": "p-4 rounded-xl rounded-t-xl py-4",
                    chevrons: ['chevron-up', 'chevron-down'],
                    customLabel: ""
                  }, {
                    "custom-label": _withCtx(() => [
                      _createVNode("div", _hoisted_62, [
                        _createTextVNode(_toDisplayString(_ctx.$t("codReconcile.detail.pengirimanBerhasil")) + ": ", 1),
                        _createVNode("span", _hoisted_63, _toDisplayString(_ctx.successfulDeliverySummary.count) + " STT", 1),
                        _hoisted_64,
                        _createVNode("span", _hoisted_65, "(" + _toDisplayString(_ctx.successfulDeliverySummary.pieces) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ")", 1)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_66, [
                        _createVNode(_component_TableV2, {
                          class: "my-2",
                          columns: _ctx.columnSuccessful,
                          data: _ctx.successfulDelivery,
                          isShowPagination: false,
                          isNoPaddingBottom: "",
                          borderBottom: false,
                          borderTop: false,
                          isSpaceTop: false,
                          loading: _ctx.successDeliveryLoading,
                          iconColor: "green-lp-100",
                          pinnedSubstractHeight: "220px"
                        }, null, 8, ["columns", "data", "loading"])
                      ]),
                      (_ctx.successfulDelivery.length === 0)
                        ? (_openBlock(), _createBlock(_component_EmptyState, {
                            key: 0,
                            customClass: "text-sm text-center cod-reconcile-detail-empty-state",
                            style: {"width":"320px"},
                            customHeaderMessage: _ctx.$t('codReconcile.detail.emptyHeaderDelivery'),
                            customMessage: _ctx.$t('codReconcile.detail.emptyMessageDelivery')
                          }, null, 8, ["customHeaderMessage", "customMessage"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "label", "border-header"]),
                  _createVNode(_component_Accordion, {
                    modelValue: _ctx.failedDeliveryExpand,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.failedDeliveryExpand = $event)),
                    label: _ctx.$t('codReconcile.detail.pengirimanGagal'),
                    class: "font-montserrat font-semibold text-20px text-black-lp-200 mb-3",
                    "border-header": 
                `border-failed-delivery ${
                  _ctx.failedDeliveryExpand ? 'accordion-radius' : ''
                }`
              ,
                    mainBorderEdge: "",
                    "border-body": "accordion-body-radius ",
                    "custom-class": "p-4 rounded-xl rounded-t-xl py-4",
                    chevrons: ['chevron-up', 'chevron-down'],
                    customLabel: ""
                  }, {
                    "custom-label": _withCtx(() => [
                      _createVNode("div", _hoisted_67, [
                        _createTextVNode(_toDisplayString(_ctx.$t("codReconcile.detail.pengirimanGagal")) + ": ", 1),
                        _createVNode("span", _hoisted_68, _toDisplayString(_ctx.failedDeliverySummaryTotalStt) + " STT", 1),
                        _hoisted_69,
                        _createVNode("span", _hoisted_70, "(" + _toDisplayString(_ctx.failedDeliverySummaryTotalPieces) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ")", 1)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_71, [
                        _createVNode(_component_TableV2, {
                          class: "my-2",
                          columns: _ctx.columnFailed,
                          data: _ctx.failedDelivery,
                          isShowPagination: false,
                          isNoPaddingBottom: "",
                          borderBottom: false,
                          borderTop: false,
                          isSpaceTop: false,
                          loading: _ctx.failedDeliveryLoading,
                          iconColor: "green-lp-100",
                          pinnedSubstractHeight: "150px"
                        }, null, 8, ["columns", "data", "loading"])
                      ]),
                      (_ctx.failedDelivery.length === 0)
                        ? (_openBlock(), _createBlock(_component_EmptyState, {
                            key: 0,
                            customClass: "text-sm text-center cod-reconcile-detail-empty-state",
                            style: {"width":"320px"},
                            customHeaderMessage: _ctx.$t('codReconcile.detail.emptyHeaderDelivery'),
                            customMessage: _ctx.$t('codReconcile.detail.emptyMessageDelivery')
                          }, null, 8, ["customHeaderMessage", "customMessage"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "label", "border-header"]),
                  _createVNode("div", _hoisted_72, [
                    (_ctx.type === 'courier')
                      ? (_openBlock(), _createBlock(_component_Accordion, {
                          key: 0,
                          modelValue: _ctx.onDeliveryExpand,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.onDeliveryExpand = $event)),
                          label: _ctx.$t('codReconcile.detail.dalamPengiriman'),
                          class: "font-montserrat font-semibold text-20px text-black-lp-200",
                          "border-header": 
                  `border-on-delivery ${
                    _ctx.onDeliveryExpand ? 'accordion-radius' : ''
                  }`
                ,
                          mainBorderEdge: "",
                          "border-body": "accordion-body-radius ",
                          "custom-class": "p-4 rounded-xl rounded-t-xl py-2",
                          chevrons: ['chevron-up', 'chevron-down'],
                          customWidthHeader: "w-19/20",
                          customLabel: ""
                        }, {
                          "custom-label": _withCtx(() => [
                            _createVNode("div", _hoisted_73, [
                              _createVNode("div", _hoisted_74, [
                                _createTextVNode(_toDisplayString(_ctx.$t("codReconcile.detail.dalamPengiriman")) + ": ", 1),
                                _createVNode("span", _hoisted_75, _toDisplayString(_ctx.onDeliverySummary.count) + " STT", 1),
                                _hoisted_76,
                                _createVNode("span", _hoisted_77, "(" + _toDisplayString(_ctx.onDeliverySummary.pieces) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ")", 1)
                              ]),
                              _createVNode(_component_DatePicker, {
                                class: "w-1/4",
                                modelValue: _ctx.onDeliveryFilterDate,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.onDeliveryFilterDate = $event)),
                                maxDate: _ctx.maxDate,
                                showButtonBar: true,
                                onClick: _cache[7] || (_cache[7] = 
                        (e) => {
                          e.stopPropagation();
                        }
                      ),
                                onSelected: _ctx.onDeliveryDateSelected,
                                onClear: _ctx.onDeliveryDateSelected
                              }, null, 8, ["modelValue", "maxDate", "onSelected", "onClear"])
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode("div", _hoisted_78, [
                              _createVNode(_component_TableV2, {
                                class: "my-2",
                                columns: _ctx.columnOnDelivery,
                                data: _ctx.onDelivery,
                                isShowPagination: false,
                                isNoPaddingBottom: "",
                                borderBottom: false,
                                borderTop: false,
                                isSpaceTop: false,
                                loading: _ctx.onDeliveryLoading,
                                iconColor: "green-lp-100",
                                pinnedSubstractHeight: "150px"
                              }, null, 8, ["columns", "data", "loading"])
                            ]),
                            (_ctx.onDelivery.length === 0)
                              ? (_openBlock(), _createBlock(_component_EmptyState, {
                                  key: 0,
                                  customClass: "text-sm text-center cod-reconcile-detail-empty-state",
                                  style: {"width":"320px"},
                                  customHeaderMessage: _ctx.$t('codReconcile.detail.emptyHeaderDelivery'),
                                  customMessage: _ctx.$t('codReconcile.detail.emptyMessageDelivery')
                                }, null, 8, ["customHeaderMessage", "customMessage"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label", "border-header"]))
                      : _createCommentVNode("", true)
                  ])
                ], 64))
              : (_ctx.activeMenu === 'riwayat-setor-uang')
                ? (_openBlock(), _createBlock("div", {
                    key: 1,
                    class: 
                `${
                  _ctx.dataHistoryAmount.length ? 'border border-1 rounded-lg' : ''
                }`
              
                  }, [
                    _createVNode(_component_TableV2, {
                      columns: _ctx.columns,
                      data: _ctx.dataHistoryAmount,
                      loading: _ctx.isLoading,
                      onRequest: _ctx.getHistoryAmount,
                      errorCause: _ctx.errorCause,
                      isSpaceTop: false,
                      isNoPaddingBottom: "",
                      bgHeader: "bg-white",
                      borderBottom: false,
                      borderTop: false,
                      hidePagination: ""
                    }, null, 8, ["columns", "data", "loading", "onRequest", "errorCause"])
                  ], 2))
                : (_ctx.activeMenu === 'riwayat-setor-paket')
                  ? (_openBlock(), _createBlock("div", {
                      key: 2,
                      class: 
                `${
                  _ctx.dataHistoryPackage.length ? 'border border-1 rounded-lg' : ''
                }`
              
                    }, [
                      _createVNode(_component_TableV2, {
                        columns: _ctx.columnsPackage,
                        data: _ctx.dataHistoryPackage,
                        loading: _ctx.isLoading,
                        onRequest: _ctx.getHistoryPackage,
                        errorCause: _ctx.errorCause,
                        isSpaceTop: false,
                        isNoPaddingBottom: "",
                        bgHeader: "bg-white",
                        borderBottom: false,
                        borderTop: false,
                        hidePagination: ""
                      }, null, 8, ["columns", "data", "loading", "onRequest", "errorCause"])
                    ], 2))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "onChange", "data"])
      ]),
      (_ctx.popupSetorHarianModelValue)
        ? (_openBlock(), _createBlock(_component_PopupSetorHarian, {
            key: 0,
            modelValue: _ctx.popupSetorHarianModelValue,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.popupSetorHarianModelValue = $event)),
            detailDataCourier: _ctx.detailDataCourier,
            filterDate: _ctx.dailyDepositDateFilterDateString,
            isPicShuttle: _ctx.type === 'pic',
            type: _ctx.type,
            onClose: _ctx.onCloseDepositDaily
          }, null, 8, ["modelValue", "detailDataCourier", "filterDate", "isPicShuttle", "type", "onClose"]))
        : _createCommentVNode("", true),
      (_ctx.openPopupAmountDue)
        ? (_openBlock(), _createBlock(_component_PopupHarusDisetor, {
            key: 1,
            modelValue: _ctx.openPopupAmountDue,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.openPopupAmountDue = $event)),
            detailDataCourier: _ctx.detailDataCourier,
            filterDate: _ctx.filterDate,
            onDeposit: _ctx.openDailyDepositFromAmountDue,
            onClose: _ctx.closeAmountDue
          }, null, 8, ["modelValue", "detailDataCourier", "filterDate", "onDeposit", "onClose"]))
        : _createCommentVNode("", true),
      _createVNode(_component_WidgetDownload),
      _createVNode(_component_PopupBerhasilSetorPaket, {
        modelValue: _ctx.modalPopUpBerhasilSetorPaket,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.modalPopUpBerhasilSetorPaket = $event)),
        isSetorUang: _ctx.activeMenu === 'riwayat-setor-uang',
        data: _ctx.detailSetorUang
      }, null, 8, ["modelValue", "isSetorUang", "data"])
    ]),
    _: 1
  }, 8, ["onBack", "error", "errorType", "onTryAgain", "loading"]))
}